import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAC6vBYOkzXS01ubIZVHVFGibMZrcQGGz4",
  authDomain: "connectstudents-1d0f6.firebaseapp.com",
  projectId: "connectstudents-1d0f6",
  storageBucket: "connectstudents-1d0f6.firebasestorage.app",
  messagingSenderId: "668416002163",
  appId: "1:668416002163:web:7adcfc10956531e9158206",
  measurementId: "G-QS9Q6WZGVK"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;
